import React from 'react';
import { Spinner } from './Spinner/Spinner';

export default function SpinnerWheel(props) {
	return <Spinner {...props} size={props.wheelSize} />;
}
